var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.182,
    height: 200,
    viewBox: "0 0 200.182 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #717402;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(-245 1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(245 -1011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-credit-card",
    "data-name": "Icon feather-credit-card",
    transform: "translate(252 -983.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M17.614-2.5H168.568a24.642,24.642,0,0,1,24.614,24.614V122.75a24.642,24.642,0,0,1-24.614,24.614H17.614A24.642,24.642,0,0,1-7,122.75V22.114A24.642,24.642,0,0,1,17.614-2.5ZM168.568,131.681a8.942,8.942,0,0,0,8.931-8.931V22.114a8.942,8.942,0,0,0-8.931-8.931H17.614a8.942,8.942,0,0,0-8.931,8.931V122.75a8.942,8.942,0,0,0,8.931,8.931Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-2",
    d: "M185.341,22.182H.841A7.841,7.841,0,0,1,.841,6.5h184.5a7.841,7.841,0,1,1,0,15.682Z",
    transform: "translate(0 41.318)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.32e56e7dbebde5233cd3e6ed139ee819.svg";
export { ForwardRef as ReactComponent };